var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445,
    height: 450,
    viewBox: "0 0 445 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_home",
    transform: "translate(4913 19360)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 445,
    height: 450,
    transform: "translate(-4913 -19360)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Enthusiastic-cuate",
    transform: "translate(-4934.46 -19381.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 133.02,
    height: 203.96,
    transform: "translate(75.71 44.01)",
    fill: "#b97070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 56.17,
    height: 90.72,
    transform: "translate(82.96 52.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 56.17,
    height: 90.72,
    transform: "translate(145.31 52.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 56.17,
    height: 90.72,
    transform: "translate(82.96 149.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 56.17,
    height: 90.72,
    transform: "translate(145.31 149.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 31.51,
    height: 291.8,
    transform: "translate(75.71 44.01)",
    fill: "#e0f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M101.24,57.88l.24,31.55.09,31.55.17,63.1-.17,63.1-.08,31.55-.25,31.55L101,278.73l-.09-31.55-.17-63.1.17-63.1L101,89.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M86.78,65.2l.24,28.17.14,28.17.11,56.34-.11,56.35-.14,28.17-.24,28.17-.25-28.17-.14-28.17-.11-56.35.11-56.34.14-28.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M94.01,71.85l.24,32.99.09,32.98.17,65.98-.17,65.97-.09,32.99-.24,32.98-.25-32.98-.08-32.99-.17-65.97.17-65.98.09-32.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M81.39,59.55l.25,34.52.09,34.52.16,69.05-.16,69.05-.09,34.53-.25,34.52-.24-34.52-.09-34.53-.16-69.05.16-69.05.09-34.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 31.51,
    height: 291.8,
    transform: "translate(208.73 335.81) rotate(180)",
    fill: "#e0f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M183.19,57.88l.25,31.55.09,31.55.16,63.1-.16,63.1-.09,31.55-.25,31.55-.24-31.55-.09-31.55-.17-63.1.17-63.1.09-31.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M197.66,65.2l.24,28.17.14,28.17.12,56.34-.11,56.35-.14,28.17-.25,28.17-.24-28.17-.14-28.17-.12-56.35.12-56.34.14-28.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M190.43,71.85l.24,32.99.09,32.98.17,65.98-.17,65.97-.09,32.99-.24,32.98-.25-32.98-.09-32.99-.16-65.97.17-65.98.09-32.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M203.04,59.55l.24,34.52.09,34.52.17,69.05-.17,69.05-.08,34.53-.25,34.52-.24-34.52-.09-34.53-.17-69.05.17-69.05.09-34.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 53.02,
    cy: 53.02,
    r: 53.02,
    transform: "translate(244.511 97.043) rotate(-45)",
    fill: "#de90b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M335.64,147.55A53,53,0,1,1,335,46.36a46,46,0,1,0,22.23,13.47,53,53,0,0,1-21.63,87.72Z",
    fill: "#dbdbdb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M299.29,92.49a7.47,7.47,0,1,1-9.38-4.83A7.47,7.47,0,0,1,299.29,92.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M347.52,77.07a7.47,7.47,0,1,1-9.38-4.84,7.47,7.47,0,0,1,9.38,4.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M326.32,81.47a11.25,11.25,0,1,1-21.431,6.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M326.1,88.94a11.25,11.25,0,0,1-16.7,5.34,13.47,13.47,0,0,1,16.7-5.34Z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 38.19,
    cy: 38.19,
    r: 38.19,
    transform: "translate(358.664 230.064) rotate(-76.32)",
    fill: "#abc3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M395.1,238.91a38.19,38.19,0,1,1,38.73-61.75,33.13,33.13,0,1,0,8.31,16.78,38.21,38.21,0,0,1-47,45Z",
    fill: "#dbdbdb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M429.55,200.65a5.37,5.37,0,1,1-.56-4.076A5.37,5.37,0,0,1,429.55,200.65Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M394.27,191.4a5.38,5.38,0,1,1-3.83-6.56,5.38,5.38,0,0,1,3.83,6.56Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M397.9,189.94a12,12,0,0,0,1.9,6.54,9.26,9.26,0,0,0,5.35,3.53,9,9,0,0,0,6.39-.35,13.3,13.3,0,0,0,5.11-4.56,10.34,10.34,0,0,1-4.45,5.8,9,9,0,0,1-3.68,1.22,11,11,0,0,1-3.85-.38,11.77,11.77,0,0,1-3.48-1.63,8.85,8.85,0,0,1-2.58-2.9,9.7,9.7,0,0,1-.71-7.27Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 88.24,
    height: 122.11,
    transform: "translate(342.28 275.06)",
    fill: "#a56767"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 96.79,
    height: 4.53,
    transform: "translate(338 270.53)",
    fill: "#b47070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 30.44,
    height: 4.53,
    transform: "translate(434.79 270.53)",
    fill: "#a56767"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 29.9,
    height: 122.11,
    transform: "translate(430.52 275.06)",
    fill: "#deaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M421,331.59H351.76V292.43H421Zm-69-.25h68.77V292.68H352Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 13.48,
    height: 7.75,
    transform: "translate(376.73 303.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M394.32,311.17H380.59v-6.83h13.73Zm-13.48-.25h13.23v-6.33H380.84Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M421,380.75H351.76V341.59H421Zm-69-.25h68.77V341.84H352Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 13.48,
    height: 7.75,
    transform: "translate(376.73 353.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M394.32,360.33H380.59V353.5h13.73Zm-13.48-.25h13.23v-6.33H380.84Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M65.21,239.56l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.14-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45h6.54l6.58.12Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M50.44,253.67l-13.13.27-6.66.12c-2.23,0-4.46,0-6.69.05h-.45v-.44l-.05-11.19V242H37.2c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0L50.29,248c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42.05-8.83.16-13.24.16L24,243l.49-.49-.05,11.19-.44-.45c2.18,0,4.35,0,6.54.05l6.58.12Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M461.27,253.67l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19V242H448c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M446.5,55.2l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44V55.2L419.52,44v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28V44c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17L420,44.51l.5-.5V55.2l-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M461.27,69.31l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M65.21,55.2l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45V55.2L38.23,44v-.5h.5L52,43.57c4.41,0,8.82.12,13.24.17h.27V44c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.12-3.71-.14-5.54l.28.27c-4.42,0-8.83.16-13.24.17l-13.24.06.5-.5L39.17,55.2l-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 115.81,
    cy: 16.8,
    rx: 115.81,
    ry: 16.8,
    transform: "translate(134.19 436.63)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M34.56,397.17l53.86-.24,53.86-.09L250,396.67l107.72.17,53.86.09,53.86.24-53.86.25-53.86.08L250,397.67l-107.72-.17-53.86-.08Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M98.8,317.31A64.921,64.921,0,0,0,96.73,329c.11.2.09.92,0,.72,0,.64-1,.53-1-.11v-1.22c-2.28-2.84-5.6-4.64-8.29-7.11a15.53,15.53,0,0,1-4.54-7.22c-2.22-7.67-.14-15.8-2.81-23.45-2.31-6.59-6.45-12.33-9.95-18.3-3.7-6.32-6.42-13-6.7-20.36-.21-5.67.46-13.22,4.78-17.47,4.57-4.5,10.24-1.12,13.75,2.89,10.17,11.63,14.87,26.4,16.77,41.46,1,8.34,2.13,16.73,1.88,25.14a67.25,67.25,0,0,1-1.82,13.34Z",
    fill: "#d4efbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M96.78,332.07a144.389,144.389,0,0,0-.28-23.62s0,0,0-.08c.13-6.39.63-12.75.38-19.14a113.579,113.579,0,0,0-2.81-20.52c0-.08-.14-.06-.12,0a134,134,0,0,1,2.22,20.07q.2,5.42-.09,10.82c-.06,1.17-.17,2.35-.24,3.54h0a126.26,126.26,0,0,0-19-50.27c-.13-.21-.5,0-.37.23A131.4,131.4,0,0,1,92,290.38c-4.89-9.05-12.26-16.49-17.74-25.19,0-.05-.1,0-.08.05,4.92,9.68,13,17.32,18.22,26.85.9,3.89,1.63,7.82,2.18,11.76a133.43,133.43,0,0,1,1.18,16.34,180.365,180.365,0,0,1-8.5-16.76c-.06-.16-.29-.05-.24.1,2.07,6.11,4.86,12.69,8.75,17.9,0,3.87-.09,7.74-.32,11.6-.6,10.31-2.37,20.49-3.18,30.76a.24.24,0,0,0,.47.06,237.678,237.678,0,0,0,4.04-31.78Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M85.83,252.55c0-.07-.14,0-.11,0,1.88,5.21,2.94,10.49,4.3,15.83a.2.2,0,0,0,.39-.07C89.86,263,87.93,257.54,85.83,252.55Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M133.65,274.38a77.741,77.741,0,0,1-4.33,8.9c-3.39,6.16-6.93,11.8-7.57,19-.28,3.2-.38,6.42-1.36,9.5a28.241,28.241,0,0,1-3.79,7.44c-3.67,5.36-8.27,10-11.67,15.53a65.219,65.219,0,0,0-7.76,18.7c-.09.36-.65.27-.57-.09a.24.24,0,0,0,0-.08.15.15,0,0,1,0-.08c-.54-15.38.69-30.87,5.38-45.6a157.458,157.458,0,0,1,7.45-19c2.51-5.34,5.64-10.48,10-14.47,2.86-2.58,9.07-7.46,13.14-4.88C134.57,270.5,134.42,272.46,133.65,274.38Z",
    fill: "#d4efbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M118.2,309.24a125.872,125.872,0,0,1-8.94,12.84c-1.48,1.95-3,3.87-4.48,5.82-.7.92-1.49,1.83-2.13,2.82.4-1.62.8-3.23,1.21-4.85,2-7.77,3.89-15.61,6.85-23.08a157.246,157.246,0,0,1,10.67-20.93c.11-.17-.18-.3-.29-.13-3.24,5.34-6.54,10.68-9.27,16.31a86.1,86.1,0,0,0-3.94,9.68A149.841,149.841,0,0,1,113.12,287c0-.06-.07-.1-.09,0a70.839,70.839,0,0,0-5.44,21.51h0c-.67,2-1.28,4-1.85,6-2.42,8.6-4.55,17.29-6.52,26a92.581,92.581,0,0,1,1.48-17.1c0-.13-.17-.16-.2,0a54.24,54.24,0,0,0-1.49,18q-1.11,5-2.18,10c-1.51,7.09-3.36,14.3-4.25,21.5a.15.15,0,0,0,.29.05c1.05-3.88,1.69-7.91,2.55-11.83s1.76-7.88,2.67-11.8c1.34-5.73,2.74-11.43,4.16-17.13,1-2.09,2.8-3.95,4.18-5.7,1.51-1.92,3-3.85,4.5-5.8a86.711,86.711,0,0,0,7.4-11.45C118.38,309.21,118.25,309.16,118.2,309.24Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M118.86,302.66a79.65,79.65,0,0,0-8.75,13.9c0,.06.07.12.11.06,2.94-4.61,5.83-9.26,8.77-13.87C119,302.67,118.91,302.59,118.86,302.66Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M53.4,289c2,3.43,4.27,7.55,3.41,11.67-.54,2.61-2.45,4.73-2.79,7.39-.78,5.87,5.08,9.75,9.31,12.53,10.56,6.93,25,13.1,27,27.25.07.5.94.37.88-.12a.29.29,0,0,0,0-.09v-.08A54.22,54.22,0,0,0,91,325.9c-1.57-7.29-4.76-13.84-8.51-20.25-6.36-10.84-13.09-21.94-22.69-30.24-2.66-2.3-8.11-6.43-10.23-1.25S51,284.77,53.4,289Z",
    fill: "#d4efbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M63.06,311.94c7,7.58,18.13,11.83,24.16,20.32a85,85,0,0,0-18.57-34.88A.27.27,0,0,1,69,297a68.63,68.63,0,0,1,15.17,22,98.421,98.421,0,0,0-6.53-16.71.18.18,0,0,1,.31-.18,63.9,63.9,0,0,1,7,18.78c7.94,19.22,8.68,41.76,7,62a.23.23,0,1,1-.46,0c.46-16,.2-32.21-3.62-47.8-.08-.32-.17-.64-.25-1-6.56-9.14-17.64-13.37-24.77-22.05C62.87,312,63,311.86,63.06,311.94Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M61.44,305.43c3.68,3.37,7.29,6.82,11,10.19v.07a53.739,53.739,0,0,1-11.14-10C61.1,305.5,61.29,305.29,61.44,305.43Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M60.86,290.82a115.65,115.65,0,0,0,11,15.13c0,.06,0,.15-.1.09a53.53,53.53,0,0,1-11.1-15.1.12.12,0,0,1,.2-.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M77.41,397.17h32.18l-4.33-43.3H82.36Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M81.56,360.9h24.41l-.71-7.03H82.36Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 30.17,
    height: 6.91,
    transform: "translate(108.59 355.98) rotate(180)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M233.74,351l28.46,37.59c5.48,7.16,10.15,13.53,12.26,17.05v.06a6.32,6.32,0,0,1,1.17,2.61v.08c-1,3.07-56.93,48.5-59.42,49.43s-5.32-6.07-4.56-9.57,14.4-30.47,14.4-30.47L198,379.92Z",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M256.36,380.84l5.84,7.71c5.48,7.16,10.15,13.53,12.26,17.05v.06a12.7,12.7,0,0,1,1.17,2.61v.08c-1,3.07-56.93,48.5-59.42,49.43s-5.32-6.07-4.56-9.57,14.4-30.47,14.4-30.47L220,410Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M216.23,457.78c2.49-.92,58.39-46.35,59.42-49.43.41-1.17-5.73-9.7-13.45-19.79l-.25-.32-36.39,28.91.51.6s-13.62,27-14.4,30.47S213.75,458.72,216.23,457.78Z",
    fill: "#a51021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M215.1,455.1c9.24-7.89,47.23-38.83,57-45.93.08-.06.13,0,.05.06-9,8-47.23,38.66-56.88,46C215,455.41,214.91,455.27,215.1,455.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M223.13,420.32c3.14-3.71,8.14-6.82,13.12-6.48.2,0,.17.28,0,.34a67.3,67.3,0,0,0-12.75,6.6.31.31,0,0,1-.37-.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M221.76,424.11c3.15-3.71,8.15-6.82,13.13-6.48.19,0,.17.28,0,.34a67.229,67.229,0,0,0-12.75,6.59.3.3,0,0,1-.38-.45Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M220.4,427.9c3.14-3.71,8.14-6.83,13.12-6.49.19,0,.17.29,0,.35a67.839,67.839,0,0,0-12.75,6.59.3.3,0,0,1-.37-.45Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M260.09,383.63l-38.95,32.64S176.32,359,166.21,330.13c-7.19-20.57,26-123.51,26-123.51l42.47-2.87s-27.49,99.14-24.44,108.77C214,324.25,260.09,383.63,260.09,383.63Z",
    fill: "#121569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M216.81,406.9c6.05-5,4.24-3.67,10.36-8.62,3-2.43,22.65-18.35,25.84-20.13.07,0,.15.07.1.13-2.45,2.7-22.39,18.28-25.42,20.65-6.21,4.84-4.48,3.38-10.74,8.15a.114.114,0,1,1-.14-.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M247.16,376.56Q236.27,363,226,348.9c-6.8-9.32-13.51-18.78-19.61-28.57a30.75,30.75,0,0,1-3.51-7.08,18.62,18.62,0,0,1-.3-8.75c.95-5.79,2.16-11.55,3.37-17.29q3.66-17.28,8.32-34.34c3.1-11.36,6.57-22.62,10.24-33.81.45-1.37.91-2.75,1.37-4.13.07-.2-.25-.28-.32-.08q-6.18,16.82-11.1,34.06t-8.77,34.55q-1.92,8.73-3.57,17.54a36.671,36.671,0,0,0-1,8.72,19.19,19.19,0,0,0,2.09,7.33,58.909,58.909,0,0,0,4.29,7.05q2.42,3.64,4.9,7.26,5,7.29,10.2,14.43c6.9,9.44,14,18.79,21.63,27.66.93,1.09,1.87,2.17,2.8,3.25C247.06,376.8,247.24,376.66,247.16,376.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M234.72,203.75s-8,28.92-14.92,57c-7.73-16-20.91-43.56-25.34-54.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M285.23,269.67l25.38-33.36c5.92-6.79,11.23-12.65,14.26-15.42a.07.07,0,0,1,.05,0c1.14-1,1.95-1.65,2.33-1.66h.07c3.22.39,58.91,46.09,60.31,48.34s-4.89,6.43-8.47,6.38-32.73-8-32.73-8l-27,33.37Z",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M327.25,219.19h.07c3.22.4,58.91,46.1,60.31,48.35s-4.89,6.43-8.46,6.38-32.74-8-32.74-8l-4.86,6.69c-9.18-7.43-25.92-21-36.08-29.53,2.83-4,5.12-6.72,5.13-6.73,5.91-6.8,11.21-12.65,14.24-15.41l.06-.05C326.06,219.8,326.87,219.2,327.25,219.19Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M387.63,267.52c-1.4-2.25-57.09-47.95-60.31-48.34-1.22-.17-8.35,7.55-16.7,17.13l-.26.31L346,266.5l.49-.62s29.14,8,32.73,8S389.05,269.76,387.63,267.52Z",
    fill: "#a51021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M385.23,269.16c-9.57-7.47-47.49-38.52-56.39-46.63-.07-.07,0-.12.05-.06,9.65,7.2,47.32,38.55,56.47,46.54C385.55,269.17,385.43,269.32,385.23,269.16Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M349.55,268.25c-4.26-2.34-8.32-6.62-9-11.57a.186.186,0,0,1,.34-.09,67.629,67.629,0,0,0,9,11.18.3.3,0,0,1-.34.48Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M353.53,268.83c-4.26-2.34-8.31-6.62-9-11.57a.176.176,0,0,1,.33-.08,67.508,67.508,0,0,0,9,11.17.31.31,0,0,1-.33.48Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M357.51,269.41c-4.25-2.34-8.31-6.62-9-11.56a.183.183,0,0,1,.34-.09,67.14,67.14,0,0,0,9,11.17.31.31,0,0,1-.34.48Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M193,206.53v.05c.25.86,4.15,14.43,8,26.06,2.82,8.49,5.64,15.93,7,16.63,1.55.78,9.06,3.52,11.58,4.37,0,0,16.16,55.91,29.62,74.1,4.61,6.24,25.61,12.48,35.88,5.74,24.1-15.8,59.79-56.89,59.79-56.89l-41.58-34-29.44,39c-7.29-13.53-11.25-40.84-11.25-40.84s-1.65-27-11.55-38.21Z",
    fill: "#121569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M334.85,281.55c-6.26-4.76-4.53-3.31-10.74-8.14-3-2.37-23-17.92-25.44-20.63a.08.08,0,0,1,.09-.12c3.19,1.77,22.87,17.67,25.87,20.09,6.11,4.95,4.3,3.6,10.36,8.62a.114.114,0,0,1-.14.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M249.84,234.13c-1.34-.25-2.75-.26-4.1-.38-1.1-.1-2.19-.22-3.28-.38a14.09,14.09,0,0,1-5.86-2c-1.95-1.31-3-3.44-4.08-5.49-.62-1.21-1.25-2.42-1.89-3.62l-.95-1.74a21.332,21.332,0,0,1-1.16-2.09c0-.1-.21,0-.16.06a13.185,13.185,0,0,1,.57,1.52c.22.59.43,1.19.66,1.78.4,1,.8,2.1,1.23,3.15a25.819,25.819,0,0,0,2.67,5.49c2.19,3,5.82,4.05,9.39,4.26,1,.05,2.05.06,3.07.05a21.761,21.761,0,0,0,3.87-.24.185.185,0,1,0,.02-.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M204,247.6a95.561,95.561,0,0,1,15.51,6,.171.171,0,1,1-.12.32c-5.21-1.83-10.51-3.56-15.62-5.68a.34.34,0,1,1,.23-.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M200.16,213c0-.18.31-.24.32-.05.37,6,1.11,11.28,2,16.86.42,2.6,3.49,16.87,7.94,15.51.75-.23,1.08-1,1.13-2.15a18.65,18.65,0,0,0-.9-4.38c-.71-3-1.32-6-1.78-9a82.69,82.69,0,0,1-1-17.07.15.15,0,0,1,.29,0,155.341,155.341,0,0,0,3,23.45c.82,3.71,3.09,9.23-.79,10.07s-7.18-8.42-7.84-11A86.721,86.721,0,0,1,200.16,213Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M210.32,245.74a25,25,0,0,1,1.22,2.92,6.88,6.88,0,0,1,.59,2.42.18.18,0,0,1-.31.09,8.4,8.4,0,0,1-1.21-2.32c-.41-.9-.84-1.79-1.22-2.7a.51.51,0,0,1,.93-.41Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M298.9,257.22Q289.32,271,278.57,284q-2.91,3.48-5.92,6.88c-6.51-9-9.68-19.76-12.21-30.48-.65-2.75-1.26-5.51-1.89-8.27a89.652,89.652,0,0,1-1.89-8.9c-.39-3.11-.22-6.28-.5-9.41a72.337,72.337,0,0,0-1.43-9,88.919,88.919,0,0,0-6.84-19.44c0-.08-.18,0-.15.06a119.67,119.67,0,0,1,6,17.61,76.9,76.9,0,0,1,1.66,9.29c.36,3.15.32,6.3.53,9.46a56.859,56.859,0,0,0,1.68,8.87c.63,2.75,1.24,5.51,1.87,8.26A152.261,152.261,0,0,0,263.92,275a60.17,60.17,0,0,0,8.45,16.45.3.3,0,0,0,.48,0c7.34-8.43,14.35-17.16,20.84-26.3q2.78-3.9,5.45-7.88C299.23,257.21,299,257.08,298.9,257.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M274.16,281.37a13.251,13.251,0,0,0-.68,1.21l-.21.16a2.49,2.49,0,0,0-.38.34,4.829,4.829,0,0,0-.58.84,4.51,4.51,0,0,0-.44,2,4.9,4.9,0,0,1,.66-1.84,5.1,5.1,0,0,1,.53-.78,1.56,1.56,0,0,0,.16-.2c0,.08-.08.15-.11.24a11.92,11.92,0,0,0-.54,2.29,8.261,8.261,0,0,0,0,2.22A11.6,11.6,0,0,0,273,290h.05a18.271,18.271,0,0,1,0-2.22c.09-.75.23-1.44.33-2.16a18.815,18.815,0,0,1,.41-2.09c.17-.7.31-1.43.52-2.13C274.33,281.34,274.21,281.3,274.16,281.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M228.37,138.68c-7.85,5.66-44.53,20.57-57.9,13.83-13.62-6.88-27.11-43.83-29.79-47-7.35-8.78,24.26-21.22,27.15-15.13,4.83,10.17,15.09,37.33,19.8,37.92,9.91,1.24,19-.05,34.5-.24C233,127.91,237,132.43,228.37,138.68Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M171.15,97.09s12.86,29,15.76,29.8c4.83,1.38,31,.47,40.4.63s18.45,8.48-3.81,16.79-41,12.64-53.11,9.92c-7.52-1.7-28.17-34.3-28.17-34.3Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M171.15,97.09s12.86,29,15.76,29.8c4.83,1.38,31,.47,40.4.63s18.45,8.48-3.81,16.79-41,12.64-53.11,9.92c-7.52-1.7-28.17-34.3-28.17-34.3Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M147.82,125.24c10.31-9.72,22.57-18.28,24.6-19.93.1-.08.21.09.11.17-2.08,1.51-15.06,12.9-24.6,20C147.82,125.51,147.72,125.33,147.82,125.24Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M237.33,134.15c-.4,2.94-4.15,6.55-13.83,10.16-22.25,8.32-41,12.64-53.1,9.92-1.5-.34-3.53-1.91-5.81-4.22C181.74,146.31,223.09,137.41,237.33,134.15Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M142.71,108.81c3.1,2.31,25-10.58,25.5-14.51a15.45,15.45,0,0,0-.38-4h0s1.54-8.7,5.4-15.49c3.23-5.7,8.68-13.8,5.68-15.65-4.37-2.72-12.49,6.7-16.83,12.38-1.54-3.57-3.19-6.49-4.79-7.85C152,59.24,129,80.3,130.32,87.22,131.61,93.9,139.61,106.51,142.71,108.81Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M164.06,72.28c-1.24,3.38-4.52,0-4.52,0s3.54,6,.91,9-6.35-1.36-6.63-1.66c.18.32,3.29,5.94.34,8.68s-6.17-2.08-6.37-2.4c.08.36,1.05,5.1-1.67,6.67-4.67,2.69-7.47-9.37-11.26-11.52,0,0-4.38,6-4.55,6.17,0,0-2.9-11.42.29-16.38a3.76,3.76,0,0,1,4.45-1.57s-1.34-3.58.91-5.8c1.16-1.14,4-.3,4-.3s-1-2.91,1.17-4.77c1.7-1.49,4.3-.41,4.3-.41s.38-3.22,2.61-4.17C152.54,51.88,166.71,65,164.06,72.28Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M145.89,58.1s0-.12.05-.09a33.55,33.55,0,0,1,13.8,14.41c.09.2-.19.43-.33.24A68.729,68.729,0,0,0,145.89,58.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M139.94,63.07c-.06,0,0-.14.08-.1,5.88,3.32,11.69,9.4,14.08,16.66.08.25-.1.55-.21.27C151.93,75.2,144.86,66.92,139.94,63.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M147.78,86.46c-2.56-6.87-7.06-12.23-12.48-17.07-.07-.06,0-.15.1-.12,3.29,1.65,6.43,5.09,8.64,8a19.5,19.5,0,0,1,4,9.13C148,86.51,147.84,86.61,147.78,86.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M159.66,72.28c.11.24-.35.14-.25.38.43,1,2.48,7.26.57,8.62-1.54,1.09-4.07-.22-4.84-1.11L153.19,78l1.06,2.77a12,12,0,0,1,.81,3.83,4.32,4.32,0,0,1-1.1,3.36,2.47,2.47,0,0,1-3.08.43,7.4,7.4,0,0,1-2.57-2.72l-1.8-3,.71,3.41a11.641,11.641,0,0,1,.23,2.89,4.7,4.7,0,0,1-.81,2.58,2.22,2.22,0,0,1-2.18.86,5,5,0,0,1-2.26-1.58,39.622,39.622,0,0,1-3.49-5c-.56-.86-1.11-1.73-1.71-2.57a7.36,7.36,0,0,0-2.14-2.2,7.91,7.91,0,0,1,1.9,2.36c.53.87,1,1.77,1.5,2.68a32.741,32.741,0,0,0,3.31,5.25,5.78,5.78,0,0,0,2.65,2,3.16,3.16,0,0,0,3.26-1.15,5.69,5.69,0,0,0,1.09-3.2,12.52,12.52,0,0,0-.21-3.23l-1.08.41a8.49,8.49,0,0,0,3,3.24,3.53,3.53,0,0,0,2.38.46,4.05,4.05,0,0,0,2.11-1.12,5.41,5.41,0,0,0,1.4-4.25,12.85,12.85,0,0,0-1-4.2l-.89.54c1,1.09,3.69,2.86,6.28,1.48C163.73,80,160.36,73.44,159.66,72.28Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M159.54,72.26a7.44,7.44,0,0,0,2,1,1.66,1.66,0,0,0,1.66-.34,3.36,3.36,0,0,0,.77-1.77c.12-.72.22-1.48.28-2.26a5.57,5.57,0,0,1,.5,2.33,3.34,3.34,0,0,1-.85,2.43,2.42,2.42,0,0,1-1.3.61,2.6,2.6,0,0,1-1.34-.26,3.92,3.92,0,0,1-1.72-1.74Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M256.34,218c-.21.16-64.72-7-65.25-7.83-.74-1.22,18.48-68.09,33.24-81.82,3.69-3.43,13.9-1.9,18,2.53C262.69,152.87,257.07,217.43,256.34,218Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M223.77,128.37,199,218.67l-12.67-9.09S207,151.08,213,141.77,223.77,128.37,223.77,128.37Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M223.77,128.37,199,218.67l-12.67-9.09S207,151.08,213,141.77,223.77,128.37,223.77,128.37Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M238.36,127.73s-1,34.74-1,42.9-1.89,52.72-1.89,52.72L264.82,218s-5.36-43.21-7.22-53.19S247.88,130.67,238.36,127.73Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M238.36,127.73s-1,34.74-1,42.9-1.89,52.72-1.89,52.72L264.82,218s-5.36-43.21-7.22-53.19S247.88,130.67,238.36,127.73Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M245.32,147.26c17.06,17.47,39.67,36.16,52.24,33.49,11.37-2.42,27.71-15.75,45.54-30.12,3.54-2.85-20.09-29.23-23.56-25.81-6.83,6.73-20.85,23.91-26.08,25.81-2.24.81-27.32-11.72-43.76-18C229.74,125,238.52,140.3,245.32,147.26Z",
    fill: "#eb9481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M358.76,138.48c-4.68,5.63-20.92,16.19-25,16.76s-18.14-22.91-16.58-26.88,18.77-21.72,26.09-23.23S363.61,132.64,358.76,138.48Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M332.44,109.71c-.57,3.83,4.28,2.32,4.28,2.32s-6.46,3.86-5.52,8c.91,4,6.7,2,7.12,1.85-.34.21-6.18,3.92-4.8,8,1.43,4.27,6.89,1.23,7.25,1-.26.3-3.62,4.28-1.87,7.16,3,5,11.89-5,16.59-5.06,0,0,2.85,5.61,2.93,5.83,0,0,6.81-6.94,6.36-13.27a4,4,0,0,0-3.39-3.78s3.12-2.69,2.14-6c-.51-1.68-3.64-2.36-3.64-2.36s2.4-2.26,1.35-5.11c-.83-2.28-3.84-2.61-3.84-2.61s1.3-3.24-.31-5.29C353.86,96.4,333.68,101.49,332.44,109.71Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M356.93,105.71a.06.06,0,0,0,0-.11,36.06,36.06,0,0,0-20.47,6.48c-.19.14-.05.5.19.39a73.771,73.771,0,0,1,20.28-6.76Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M360,113.48c.08,0,.06-.14,0-.14-7.26.1-15.89,2.84-21.9,8.46-.2.19-.19.57.06.37C342.39,118.73,353.34,114.57,360,113.48Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M340.48,131.52c6-5.17,13-7.9,20.61-9.67.1,0,.06-.16,0-.17-4-.15-8.7,1.49-12.28,3.07a20.75,20.75,0,0,0-8.48,6.56C340.21,131.42,340.35,131.63,340.48,131.52Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M336.72,112a22.249,22.249,0,0,0-3.25,2.87,7.929,7.929,0,0,0-2.11,3.57,2.62,2.62,0,0,0,.29,1.85,3.77,3.77,0,0,0,1.36,1.36,4.69,4.69,0,0,0,3.78.1l3-1.1-2.42,2.07a12.88,12.88,0,0,0-2.75,3.19,4.68,4.68,0,0,0-.69,3.75,2.67,2.67,0,0,0,2.68,2,8.06,8.06,0,0,0,3.83-1.24l3.25-1.91-2.43,2.85a12.311,12.311,0,0,0-1.71,2.62,5.091,5.091,0,0,0-.57,2.85,2.4,2.4,0,0,0,1.61,1.94,5.29,5.29,0,0,0,2.95-.32,41.907,41.907,0,0,0,5.87-2.88c1-.53,1.94-1.06,2.94-1.55a7.86,7.86,0,0,1,3.16-1,8.509,8.509,0,0,0-3,1.24c-1,.56-1.87,1.16-2.8,1.76a35.228,35.228,0,0,1-5.84,3.25,6.17,6.17,0,0,1-3.52.5,3.4,3.4,0,0,1-2.49-2.77,6.26,6.26,0,0,1,.61-3.56,13.9,13.9,0,0,1,1.86-2.94l.82.95a9.29,9.29,0,0,1-4.52,1.51,3.88,3.88,0,0,1-2.48-.8,4.32,4.32,0,0,1-1.42-2.15,5.91,5.91,0,0,1,.87-4.74,14.4,14.4,0,0,1,3.08-3.47l.57,1a5.55,5.55,0,0,1-4.67-.37,4.67,4.67,0,0,1-1.6-1.76,3.4,3.4,0,0,1-.26-2.38,8.13,8.13,0,0,1,2.51-3.69,19.35,19.35,0,0,1,3.49-2.6Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M319.54,124.82s8.83-29.79,18.78-20.63c3,2.72,11.85,17.42,8.94,19.27-3.77,2.38-8.63-3.07-11.14-7,0,0-1.58,10.55-9.25,11.65a7.71,7.71,0,0,1-7.33-3.29Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M337.45,103.48a16.31,16.31,0,0,1,3.39,3.3,35,35,0,0,1,2.73,3.9,54.6,54.6,0,0,1,4.34,8.48,9,9,0,0,1,.6,2.45,3.4,3.4,0,0,1-.18,1.43,2.48,2.48,0,0,1-.39.7,2.59,2.59,0,0,1-.59.52,4,4,0,0,1-2.72.53,7.67,7.67,0,0,1-2.44-.9,14.36,14.36,0,0,1-3.7-3.22,32,32,0,0,1-2.83-3.88l1-.23a19.661,19.661,0,0,1-1,3.51,17.077,17.077,0,0,1-1.63,3.22,12.32,12.32,0,0,1-2.39,2.7,9.38,9.38,0,0,1-3.11,1.74,10.68,10.68,0,0,0,2.85-2,13,13,0,0,0,2.06-2.78,17.89,17.89,0,0,0,1.38-3.17,18.935,18.935,0,0,0,.76-3.34l.17-1.4.83,1.17a36.317,36.317,0,0,0,2.84,3.65,14.261,14.261,0,0,0,3.42,2.91c1.23.69,2.77,1.06,3.79.4.95-.5.58-2.19.1-3.58a43.722,43.722,0,0,0-1.8-4.28c-.65-1.42-1.33-2.83-2.07-4.2C341.32,108.39,339.77,105.61,337.45,103.48Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M316.07,128.19s-20.68,21.09-23.7,20.9c-5-.32-35.39-14.73-44.3-17.73s-18.46-1.23-4.38,15.41c15.89,18.77,33.68,35.49,52.07,35.51,9.91,0,40.77-21.54,40.77-21.54Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M316.07,128.19s-20.68,21.09-23.7,20.9c-5-.32-35.39-14.73-44.3-17.73s-18.46-1.23-4.38,15.41c15.89,18.77,33.68,35.49,52.07,35.51,9.91,0,40.77-21.54,40.77-21.54Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M328.63,162.53c-6.46-12.62-15.14-24.78-16.51-27-.06-.11-.22,0-.15.12,1.45,2.12,9.87,17.2,16.49,27C328.54,162.78,328.7,162.65,328.63,162.53Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M256.88,161.06a17.844,17.844,0,0,1-1.32-1.56c-.49-.53-1-1.06-1.47-1.59-1-1-1.91-2-2.86-3.07-1.89-2.05-3.9-4-5.86-6h0c1.79,2.16,3.55,4.33,5.49,6.36l.13.14-1.14-.77c-.79-.53-1.58-1.06-2.36-1.6,0,0-.1.05-.06.08.73.6,1.48,1.17,2.27,1.7.4.27.8.53,1.22.78l.58.34,2.19,2.27c.5.51,1,1,1.52,1.52s1.14.9,1.6,1.45C256.83,161.25,257,161.13,256.88,161.06Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M225.92,140.61c3.06.74,10.6-3.78,14.06-8.15.23-.3.31-3.87.62-8.2.19-2.63.47-5.55.92-8.2l-17.28,1.23a42.811,42.811,0,0,1-.12,10.43,5.568,5.568,0,0,1-.3,1.07q0,.075,0,.18C223.08,131,221.13,139.45,225.92,140.61Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M223.83,128.79a.63.63,0,0,0-.06.18,10.57,10.57,0,0,0,1.69.38c9.48,1.38,13.73-9.74,14.81-13.2l-16,1.13a43,43,0,0,1-.1,10.45,6.871,6.871,0,0,1-.34,1.06Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M249.19,96.19c.25,6.23-7.18,22.12-12.26,24.76-7.37,3.83-17.26,1.79-20-6.57-2.62-8.11,7.42-28.64,12.9-30.81C237.93,80.36,248.82,87,249.19,96.19Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M235.25,99.58a14.29,14.29,0,0,1-1.15-1.06,2.5,2.5,0,0,1-1-1.3.82.82,0,0,1,.51-.85,2,2,0,0,1,1.93.61,2.91,2.91,0,0,1,1.05,1.83.86.86,0,0,1-1.34.77Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M224.57,95a15.193,15.193,0,0,0,1.55.24,2.56,2.56,0,0,0,1.62-.06.82.82,0,0,0,.35-.92,2,2,0,0,0-1.69-1.13,2.88,2.88,0,0,0-2.09.32.86.86,0,0,0,.26,1.55Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M229.06,111.86a1.74,1.74,0,0,1-1.19.25,3.17,3.17,0,0,1-1.05-.77h-.07a1.61,1.61,0,0,0,1.13,1.18,1.23,1.23,0,0,0,1.26-.59C229.19,111.9,229.11,111.84,229.06,111.86Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M229.32,108.13a4,4,0,0,1-3.18.58,5.27,5.27,0,0,1-1.35-.51,1.379,1.379,0,0,1-.24-.14,1,1,0,0,1-.22-.14.29.29,0,0,1-.12-.33h0a.541.541,0,0,1,.05-.11h0v-.09c.34-.85,1-2.08,1-2.08-.37,0-2.22,0-2-.38a60.179,60.179,0,0,1,6.24-10.56c.07-.11.25,0,.18.11-1.56,3.45-3.72,6.61-5.35,10.05a6.8,6.8,0,0,1,2,.22c.1.08-1.26,2.36-1.38,2.76a5.59,5.59,0,0,0,4.34.45C229.36,108,229.42,108.07,229.32,108.13Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M225.46,108a4.72,4.72,0,0,0,1.17,2.11,2.15,2.15,0,0,0,1.17.59c1,.15,1.33-.64,1.46-1.39a5.268,5.268,0,0,0,.06-1.21A6.21,6.21,0,0,1,225.46,108Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M226.63,110.1a2.15,2.15,0,0,0,1.17.59c1,.15,1.33-.64,1.46-1.39a2.23,2.23,0,0,0-2.63.8Z",
    fill: "#ff9bbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M234,102.23a1.8,1.8,0,0,0-.07-.94,1.32,1.32,0,0,0-.74-.71,1.18,1.18,0,0,0-1,.15,2,2,0,0,0-.61.69,4.77,4.77,0,0,0-.22.52,2.48,2.48,0,0,0-.14,1.14,4.119,4.119,0,0,1,.32-.78,5.845,5.845,0,0,1,.41-.64c.31-.41.72-.7,1.09-.54a1,1,0,0,1,.55,1.07,8.451,8.451,0,0,1-.23,1.6,3.76,3.76,0,0,0,.64-1.56Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M223.46,97.4a1.87,1.87,0,0,1,.73-.59,1.29,1.29,0,0,1,1,0,1.17,1.17,0,0,1,.61.84,2,2,0,0,1-.09.92,3.331,3.331,0,0,1-.21.52,2.53,2.53,0,0,1-.73.89,3.481,3.481,0,0,0,.34-.77,5,5,0,0,0,.18-.74c.08-.51,0-1-.36-1.16a1,1,0,0,0-1.16.34,8.141,8.141,0,0,0-1,1.28,3.56,3.56,0,0,1,.69-1.53Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M233.4,93.57a14.77,14.77,0,0,1-1.86-.56c-.61-.26-1.16-.63-1.77-.87a10.72,10.72,0,0,0-3.67-.56c-.11,0-.12.07,0,.07a9.19,9.19,0,0,1,3.79.88,11.47,11.47,0,0,0,3,1.19A11.56,11.56,0,0,1,239.27,97h0a11.63,11.63,0,0,0-5.87-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M234.05,92a13.69,13.69,0,0,1-1.76-.53c-.58-.25-1.1-.6-1.68-.83a10.1,10.1,0,0,0-3.48-.53c-.1,0-.11.06,0,.07a8.66,8.66,0,0,1,3.59.83,10.81,10.81,0,0,0,2.83,1.13,11,11,0,0,1,6.08,3.07h0A11,11,0,0,0,234.05,92Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M224.89,87.89c4.4,6.1,14.55,2.92,14.55,2.92a6.75,6.75,0,0,0,5,6.33s-2.4,10.28.21,11.19c4,1.41,10-11.6,9.74-14.7s-3.42-5-3.42-5a6.88,6.88,0,0,0-1.29-4.89c-2-3-12.32-3.62-12.32-3.62a9.3,9.3,0,0,0-1.23-4.09,2.6,2.6,0,0,0-3.65-.94,6.08,6.08,0,0,1,.07,2.77c-.57,3.06-2.93,2.2-2-.41a4.29,4.29,0,0,1,1.89-2.36c-.55-2.13-2.25-3.38-3.74-2.87C226,73.15,221.23,82.83,224.89,87.89Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M230.3,107.12a4.8,4.8,0,0,1-1.46-6.62h0a4.79,4.79,0,1,1,2.54,7.13,4.439,4.439,0,0,1-1.08-.51Zm-.92-6.28a4.15,4.15,0,1,0,5.73-1.26,3.94,3.94,0,0,0-.93-.44,4.16,4.16,0,0,0-4.8,1.7Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M221.14,102.82c-1.78-.83-2.33-3.46-1.21-5.85a5.74,5.74,0,0,1,2.33-2.61,3,3,0,0,1,4.63,2.16,5.67,5.67,0,0,1-.49,3.46c-1.06,2.27-3.23,3.53-5,3Zm1.43-7.9a5.06,5.06,0,0,0-2.06,2.32c-1,2.07-.56,4.32.9,5s3.44-.45,4.41-2.53a5.09,5.09,0,0,0,.44-3.07,2.56,2.56,0,0,0-1.35-1.93l-.22-.09a2.65,2.65,0,0,0-2.12.3Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M228.75,101.07l.58-.27c-.4-.86-1.58-2.31-3.17-1.67l.24.59C227.83,99.14,228.71,101,228.75,101.07Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M247.58,111.2h.64c0-.29-.15-2.93-1.35-3.75s-9.25-3.65-9.59-3.78l-.22.61c2.33.83,8.58,3.11,9.45,3.7S247.55,110.48,247.58,111.2Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M242.06,108.85s5.27-4.3,7.33-2.27-3,9-6.14,9.26a3,3,0,0,1-3.45-2.67Z",
    fill: "#fcc0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M247.89,108.54c.05,0,0,.08,0,.08-2.24.24-3.82,1.8-5.11,3.52a1.67,1.67,0,0,1,2.53.24.07.07,0,0,1-.08.1,1.86,1.86,0,0,0-2.15.06,9.13,9.13,0,0,0-1.39,1.32c-.15.16-.45,0-.32-.22h0C242.08,111,245.08,108,247.89,108.54Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M223.68,128.47l3.7,10.35,13.16-12.41,3.43,4.28s-13.18,20-13.22,19.08l-3.86-9-6.3,5.88,1.08-15.33Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M220.69,139.09c.27-2.52.46-5.07.84-7.58a.09.09,0,0,1,.18,0c.41,2.46-.65,12.11-.73,14.43h0c.26-.26,5.83-5.16,5.88-5.08.85,1.43,3.69,8,3.88,8.54,2.08-3.18,10-14.72,12.49-17.71a.083.083,0,0,1,.14.09c-1.86,3.37-12.41,18.92-12.56,18.87a97.358,97.358,0,0,1-4-9.46c-1,1.08-6.59,6.64-6.59,6.27a79.89,79.89,0,0,1,.47-8.37Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M280.86,259.21l-4.04.75-.9,4.25-.9-4.25-4.03-.75,4.01-.98.92-4.02.92,4.02Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M212.14,69.5l-4.04.75-.9,4.25-.9-4.25-4.03-.75,4.01-.98.92-4.02.92,4.02Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M163.74,206.01l-4.04.74-.9,4.25-.9-4.25-4.03-.74,4.01-.98.92-4.02.92,4.02Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M278.3,188.88l-4.03.75-.9,4.25-.9-4.25-4.04-.75,4.02-.98.92-4.02.92,4.02Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M330.42,172.09l-2.25.41-.51,2.38-.5-2.38-2.25-.41,2.24-.55.51-2.25.52,2.25Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M190.67,164.26l-2.25.42-.5,2.38-.51-2.38-2.25-.42,2.24-.55.52-2.24.51,2.24Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M260.53,85.16l-2.26.42-.5,2.37-.5-2.37-2.26-.42,2.25-.55.51-2.24.51,2.24Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M313.11,210.53l-2.25.41-.5,2.38-.51-2.38-2.25-.41,2.24-.55.52-2.25.51,2.25Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M294.78,215.1l-2.26.41-.5,2.38-.51-2.38-2.25-.41,2.24-.55.52-2.25.51,2.25Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M294.78,120.45l-2.26.42-.5,2.38-.51-2.38-2.25-.42,2.24-.55.52-2.24.51,2.24Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M196.92,117.05l-2.26.41-.5,2.38-.51-2.38-2.25-.41,2.25-.55.51-2.25.51,2.25Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M141.38,114.59l-2.25.42-.51,2.38-.5-2.38-2.25-.42,2.24-.55.51-2.24.52,2.24Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M171.68,226.37l-2.25.42-.5,2.37-.51-2.37-2.25-.42,2.24-.55.52-2.24.51,2.24Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M285.48,225.72a.65.65,0,1,0,.65.65A.65.65,0,0,0,285.48,225.72Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M295.41,134.07a.66.66,0,1,0,.579.655A.66.66,0,0,0,295.41,134.07Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M180.4,78a.66.66,0,1,0,.579.655A.66.66,0,0,0,180.4,78Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M130.53,119.15a.65.65,0,1,0,.65.65.65.65,0,0,0-.65-.65Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M168.93,183.88a.66.66,0,1,0,.579.655.66.66,0,0,0-.579-.655Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M149.58,171.93a.46.46,0,1,0,.46.46.46.46,0,0,0-.46-.46Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M185.54,94a.46.46,0,1,0,.46.46A.46.46,0,0,0,185.54,94Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M199.25,158.92a.47.47,0,1,0,.4.465.47.47,0,0,0-.4-.465Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M156.61,242.62a.47.47,0,1,0,.4.465.47.47,0,0,0-.4-.465Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M271.58,232.15a1.26,1.26,0,1,0,1.148,1.255,1.26,1.26,0,0,0-1.148-1.255Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M346.89,160a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,346.89,160Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M220.45,60.66a1.26,1.26,0,1,0,1.148,1.255,1.26,1.26,0,0,0-1.148-1.255Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M204,110.58a1.26,1.26,0,1,0,1.148,1.255A1.26,1.26,0,0,0,204,110.58Z",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M162.52,238.37a1.26,1.26,0,1,0,1.148,1.255A1.26,1.26,0,0,0,162.52,238.37Z",
    fill: "#ffc727"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLogo);
export default __webpack_public_path__ + "static/media/landing_logo.88fc7543.svg";
export { ForwardRef as ReactComponent };